const TEAM = [
  {
    name: "Utpal J. Ghosh",
    designation: "Founder",
    desc: "15+ years of Corporate Experience. Serial Entrepreneur",
    img: "/images/team/utpal-ghosh.jpeg",
  },
  {
    name: "Anand Dhutraj",
    designation: "Chief Mentor",
    desc: "An IIT (Bombay), IIM (Kolkata) Alumnus, 20+ years of experience",
    img: "/images/team/anand-dhutraj.jpg",
  },
  {
    name: "Jerry Austin",
    designation: "Consultant and Mentor",
    desc: "Experienced Director Of Dining Services with a demonstrated history of working in the retail and food & beverages industry",
    img: "/images/team/jerry-austin.jpeg",
  },
  {
    name: "Tanayy Goregaokar",
    designation: "Head - F&B",
    desc: "20+ years of culinary experience in F&B domain",
    img: "/images/team/tanayy-goregaokar.jpg",
  },
  {
    name: "Vineeta Mehta",
    designation: "Chief Dietician & Nutritionist",
    desc: "17+ years of working experience in the field of Dietetics. Secretary, Nutrition Society of India, Nagpur Chapter",
    img: "/images/team/vineeta-mehta.jpg",
  },
  {
    name: "Apurv Paul",
    designation: "Manager - Business Development",
    desc: "A business management graduate with 5+ years of Hospitality experience",
    img: "/images/team/apurv-paul.jpg",
  },
];

export default TEAM;
